import type React from 'react';
import type { ChartAccount, LocaleCode } from '@/api/models';
import { AccountFormView } from './AccountFormView';
import { useAccountForm } from './useAccountForm';

export type AccountFormProps = {
    /** The account to edit; omit/`null` to create. */
    account?: ChartAccount | null;
    /** The full chart — parent options + client code-uniqueness. */
    accounts: ChartAccount[];
    locale: LocaleCode;
    /** Fired after a successful create / update / archive so the host can close. */
    onSaved?: () => void;
    /** Cancel affordance (the drawer's dismiss). */
    onCancel: () => void;
};

/**
 * Self-contained account create/edit form. Decoupled from its host: the drawer
 * mounts it today, but a modal or route could reuse it unchanged (mirrors
 * `JournalEntryForm`). The container instantiates the logic hook and hands the
 * model to the render-only View.
 */
export const AccountForm: React.FC<AccountFormProps> = ({
    account = null,
    accounts,
    locale,
    onSaved,
    onCancel,
}) => {
    const form = useAccountForm({ account, accounts, locale, onSaved });
    return <AccountFormView form={form} onCancel={onCancel} />;
};
